import React, { useState, useRef, useEffect } from "react";
import {
  FormControl,
  FormControlLabel,
  Typography,
  TextField,
  RadioGroup,
  Radio,
  Checkbox,
  Button,
  Box,
  FormHelperText,
  Autocomplete,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { fetchSuppliersByCompanyId } from "../../../../redux/orderSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { updateCompanyAPI } from "../../../../redux/adminSlice";

const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
const phoneRegExp = /^\+\d{1,3}[- ]?\d{7,10}$/;
const allDigitsSame = (value) => /^(.)\1+$/.test(value);
export const ADD_EDIT_REFRRED_BY = yup.object().shape({
  referredName: yup // // not required in older one
    .string()
    // .required("Referred Name cannot be empty")
    .matches(/^[a-zA-Z ]*$/, "Name must contain only alphabets and spaces."),
  referredCompanyName: yup
    .string() // // not required in older one
    // .required("Referred Company Name cannot be empty")
    .test(
      "english-characters-only",
      "Please enter English characters only",
      (value) => !value || !nonEngChar.test(value)
    ),
  referredEmail: yup
    .string() // // not required in older one
    // .required("Referred Email cannot be empty")
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
      "Invalid email format. Example: example@example.com"
    )
    .max(255, "Email must be at most 255 characters long."),
  referredPhone: yup
    .string() // // not required in older one
    // .required("Referred Phone cannot be empty")
    .matches(/^[0-9]+$/, "Phone number must only contain digits.")
    .min(8, 'Phone number is too short.')
    .max(15, 'Phone number is too long.')
});

const AddEditRefrredBy = ({
  onSubmit,
  handleStepChange,
  actionType,
  currentStep,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    createdDate,
    modifiedDate,
    rejectedReason,
    rejectedDate,
    isActive,
    companyBuName,
    companyLogo,
    companyTypeName,
    parentCompanyName,
    user,
    ...rest
  } = location.state?.activeCompanyDetails || {};
  const initialValues = location.state?.activeCompanyDetails || {};
  const { loading } = useSelector((state) => state.order);
  const handleRefrredsubmit = (values) => {
    console.log("handleRefrredsubmit", values);
    const companyData = values;
    dispatch(updateCompanyAPI(companyData))
      .then((response) => {
        const companyDetails = response.payload;

        if (companyDetails.result === true) {
          navigate(-1);
        }
      })
      .catch((error) => {
        console.error("Fetching user details error:", error);
      });
  };
  return (
    <>
      <div className={className}>
        {actionType === "edit" && (
          <div className="ps-4 pe-4">
            <h1 className="fprimary">Refrred Details</h1>
          </div>
        )}
        <Formik
          // initialValues={editValue || defaultValues}
          initialValues={{
            referredName: initialValues.referredName === null ? "" :initialValues.referredName || "",
            referredCompanyName: initialValues.referredCompanyName  === null ? "" : initialValues.referredCompanyName || "",
            referredEmail: initialValues.referredEmail === null ? "" : initialValues.referredEmail|| "",
            referredPhone: initialValues.referredPhone === null ? "" : initialValues.referredPhone|| "",
            ...rest,
          }}
          enableReinitialize={true}
          validationSchema={ADD_EDIT_REFRRED_BY}
          onSubmit={(values, { setSubmitting }) => {
            if (location.state?.actionType === "edit") {
              handleRefrredsubmit({ ...values });
            }
            // console.log('AddEditlocation Submit:', values);
            onSubmit(values);
            setSubmitting(false);
          }}
        >
          {({
            values,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            touched,
          }) => (
            <Form onSubmit={handleSubmit}>
              <div className="card-body m-3">
                <div className="row">
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.rename")}
                      className="md-input"
                      name="referredName"
                      value={values.referredName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredName}
                      helperText={errors.referredName}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.recompany")}
                      className="md-input"
                      name="referredCompanyName"
                      value={values.referredCompanyName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredCompanyName}
                      helperText={errors.referredCompanyName}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.remail")}
                      className="md-input"
                      name="referredEmail"
                      value={values.referredEmail}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredEmail}
                      helperText={errors.referredEmail}
                    />
                  </div>
                  <div className="col-md-6 cs-form mb-3">
                    <TextField
                      label={t("companyProfile.rephone")}
                      className="md-input"
                      name="referredPhone"
                      value={values.referredPhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.referredPhone}
                      helperText={errors.referredPhone}
                    />
                  </div>

                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-light grey-btn lg-btn"
                      onClick={() => navigate(-1)}
                    >
                      {t("createOrder.back")}
                    </button>
                    {/* <Button color="primary" variant="contained" type="submit" disabled={isSubmitting}>
                Create Order
                
            </Button> */}
                    <button
                      className="btn btn-primary greeen-btn lg-btn"
                      type="submit"
                      variant="contained"
                      // onClick={handleSubmit} // Use onClick to trigger form submission
                      // disabled={ isValid || isSubmitting }
                    >
                      {/* Create Order */}
                      {/* {loading ? "Submitting..." : "Submit"} */}
                      Submit
                      {/*  t('createOrder.createOrderbtn') */}
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AddEditRefrredBy;
